import React from "react"

import Button from "@material-ui/core/Button"
import { IconButton } from "@material-ui/core"
import { IconMinus } from "../icons/IconMinus"
import { IconPlus } from "../icons/IconPlus"

import { getFormattedValue } from "../helpers"
import { DLClickEventExtended } from "../../../../helpers/WatcherDL/DLEvents"
import scrollToPersonalForm from "../../../../helpers/scrollToPersonalForm"
import { type RightBlockProps } from "../types"

import * as styles from "./rightBlock.module.scss"

const handleClickCta = () => {
  DLClickEventExtended({
    name: "Оформить карту",
    eventAction: "CTA в калькуляторе",
    placement: "calculator",
  })

  scrollToPersonalForm()
}

export function RightBlock({ paymentResult, term, terms, dispatch, data }: RightBlockProps) {
  const { title, benefitText, benefitValue, icon, iconDescr, arrowCalculator } = data

  const currentIndex = terms.findIndex((termItem) => termItem === term)

  const handleClickIconBtn = (action: "inc" | "dec") => {
    const canDecrement = action === "dec" && currentIndex > 0
    const canIncrement = action === "inc" && currentIndex < terms.length - 1

    if (!canDecrement && !canIncrement) return

    const newTerm = canDecrement ? terms[currentIndex - 1] : terms[currentIndex + 1]

    dispatch({
      type: "SET_TERM",
      payload: newTerm,
    })
  }

  const isMinusDisabled = currentIndex >= terms.length - 1
  const isPlusDisabled = currentIndex <= 0

  return (
    <div className={styles.wrapper}>
      <div className={styles.head}>
        {arrowCalculator && (
          <IconButton
            onClick={() => handleClickIconBtn("inc")}
            disabled={isMinusDisabled}
            classes={{ root: styles.iconButtonRoot }}
          >
            <IconMinus disableButton={isMinusDisabled} />
          </IconButton>
        )}
        <div className={styles.headTitle}>
          <div>{title}</div>
          <div className={styles.headValue}>{getFormattedValue(paymentResult)} ₽</div>
        </div>
        {arrowCalculator && (
          <IconButton
            onClick={() => handleClickIconBtn("dec")}
            disabled={isPlusDisabled}
            classes={{ root: styles.iconButtonRoot }}
          >
            <IconPlus disableButton={isPlusDisabled} />
          </IconButton>
        )}
      </div>

      <div className={styles.foot}>
        <div className={styles.row}>
          <div className={styles.benefitText}>{benefitText}</div>
          <div className={styles.benefitValue}>{benefitValue}</div>
        </div>
        <div className={styles.row} style={{ justifyContent: "flex-start" }}>
          <div className={styles.wrapperIcon}>{icon}</div>
          <div className={styles.iconDescr}>{iconDescr}</div>
        </div>
      </div>

      <Button className={styles.btnCTA} onClick={handleClickCta}>
        Оформить карту
      </Button>
    </div>
  )
}
